module.exports = __webpack_public_path__ + "static/media/ASPNet.e32b096b.jpg";